import axios from "axios";

const getAccessRights = async () => {
  const response = await axios.post("/account/UserGroup/GetAccessRights");

  return response.data;
};

export default getAccessRights;
